import React from 'react'
import { Nav } from 'react-bootstrap'
import { cleanSeparators } from './Utils'
import MenuModule from './MenuModule'
import SubMenuItem from './SubMenuItem'

class Menu extends React.Component {
	render() {
		const menuItems = this.props.menuItems;

		if (menuItems.length <= 0)
			return null;

		// Are we listing submenu from one parent in particular?
		if (this.props.parent) {
			const item = menuItems.filter((x) => { return x.resourceCode === this.props.parent })[0];

			if (!item)
				return null;
			else
				return cleanSeparators(item.childs).map(x => <SubMenuItem item={x} key={x.resourceCode} />);
		}

		return (
			<Nav>
				{menuItems.map((x, i) =>
					<MenuModule exclude={this.props.exclude} item={x} key={i} />
				)}
			</Nav>
		);
	}
}

export default Menu;



// WEBPACK FOOTER //
// ./src/fw/components/menu/Menu.js